var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52.917mm",
    height: "48.003mm",
    viewBox: "0 0 52.917 48.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 792h612v-792h-612z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.4776e-6 -249)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.58094 0 0 -.58094 -276.48 614.34)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(553.71 619.52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.179-5.018-4.264-9.959-6.517-14.854-0.332-0.72-1.463-1.216-2.224-1.817-0.309 0.647-0.494 1.371-0.551 2.146 0.13 0.834 0.469 1.671 0.982 2.426 3.526 5.508 5.111 11.284 6.231 17.164 0.236 1.102 0.753 2.189 1.494 3.139 1.159 1.472 2.251 1.475 3.268 0.326 2.115-2.388 4.418-4.591 6.562-6.952 1.453-1.531 2.778-3.192 3.967-4.973 0.318-0.501-0.291-1.764-0.475-2.678-0.711 0.234-1.935 0.223-2.05 0.74-0.984 4.432-5.106 5.399-8.196 8.219 0.987-5.001 2.058-9.472 2.739-14.099 1.562-9.048-1.435-19.462-8.059-28.004-5.861-7.898-13.422-13.114-20.99-18.484-7.305-5.379-15.237-9.363-23.306-11.708-9.119-2.479-18.277-4.759-26.968-3.517-1.16 0.136-2.245 0.476-3.214 1.006-0.428 0.255-0.335 1.275-0.478 1.948 0.61 0.327 1.249 0.529 1.875 0.592 13.723-2.548 27.906 0.881 42.085 8.319 6.062 3.181 11.73 7.864 17.49 12.035 2.48 1.782 4.824 3.808 6.991 6.042 8.156 8.48 14.708 21.092 11.448 32.637-0.953 3.378-1.438 7.003-2.104 10.347"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageArrow);
export default __webpack_public_path__ + "static/media/image_arrow.f5e7f686dae3c9137636505a96e17e63.svg";
export { ForwardRef as ReactComponent };